/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

export const noTopicReturnTranslations = {
  ar: [
    {
      id: 'digression_failure',
      step: 'digression_failure',
      output: {
        generic: [
          {
            values: [
              {
                text: 'عفوا، لم أستطع تأكيد ما إذا كنت تريد العودة إلى الموضوع السابق، دعني أتواصل مع أحد مسؤولي خدمة العملاء.'
              }
            ],
            response_type: 'text',
            selection_policy: 'sequential'
          }
        ]
      },
      handlers: [],
      resolver: {
        response: {
          agent_available: {
            message: 'دعنا نرسلك الى وكيل متاح. '
          },
          agent_unavailable: {
            message:
              'لا يوجد وكلاء متاحون في هذا الوقت. عندما يصبح أحدهم متاحا، سنقوم بتوصيلك. '
          },
          message_to_human_agent: '',
          transfer_info: {
            target: {}
          }
        },
        type: 'connect_to_agent'
      },
      condition: {
        eq: [
          {
            system_variable: 'fallback_reason'
          },
          {
            scalar: 'Failed to confirm topic return'
          }
        ]
      },
      next_step: 'step_001',
      variable: 'digression_failure'
    }
  ],
  cs: [
    {
      id: 'digression_failure',
      step: 'digression_failure',
      output: {
        generic: [
          {
            values: [
              {
                text: 'Je mi líto, ale nemohu potvrdit, zda jste se chtěli vrátit na předchozí téma, přepojím vás na agenta.'
              }
            ],
            response_type: 'text',
            selection_policy: 'sequential'
          }
        ]
      },
      handlers: [],
      resolver: {
        response: {
          agent_available: {
            message: 'Pošleme vás k dostupnému agentovi.'
          },
          agent_unavailable: {
            message:
              'V tuto chvíli nejsou k dispozici žádní agenti. Jakmile se nějaký uvolní, spojíme vás.'
          },
          message_to_human_agent: '',
          transfer_info: {
            target: {}
          }
        },
        type: 'connect_to_agent'
      },
      condition: {
        eq: [
          {
            system_variable: 'fallback_reason'
          },
          {
            scalar: 'Failed to confirm topic return'
          }
        ]
      },
      next_step: 'step_001',
      variable: 'digression_failure'
    }
  ],
  de: [
    {
      id: 'digression_failure',
      step: 'digression_failure',
      output: {
        generic: [
          {
            values: [
              {
                text: 'Ich habe leider nicht verstanden, ob Sie zum vorherigen Thema zurückkehren möchten. Ich werde Sie mit einem Servicemitarbeiter verbinden.'
              }
            ],
            response_type: 'text',
            selection_policy: 'sequential'
          }
        ]
      },
      handlers: [],
      resolver: {
        response: {
          agent_available: {
            message: 'Ich werde Sie mit einem freien Mitarbeiter verbinden.'
          },
          agent_unavailable: {
            message:
              'Derzeit sind keine Mitarbeiter verfügbar. Sobald einer frei wird, verbinde ich Sie.'
          },
          message_to_human_agent: '',
          transfer_info: {
            target: {}
          }
        },
        type: 'connect_to_agent'
      },
      condition: {
        eq: [
          {
            system_variable: 'fallback_reason'
          },
          {
            scalar: 'Failed to confirm topic return'
          }
        ]
      },
      next_step: 'step_001',
      variable: 'digression_failure'
    }
  ],
  en: [
    {
      id: 'digression_failure',
      step: 'digression_failure',
      output: {
        generic: [
          {
            values: [
              {
                text: "Sorry I couldn't confirm if you wanted to return to previous topic, let me connect to an agent."
              }
            ],
            response_type: 'text',
            selection_policy: 'sequential'
          }
        ]
      },
      handlers: [],
      resolver: {
        response: {
          agent_available: {
            message: "Let's send you to an available agent."
          },
          agent_unavailable: {
            message:
              "There are no agents available at this time. When one becomes available, we'll connect you."
          },
          message_to_human_agent: '',
          transfer_info: {
            target: {}
          }
        },
        type: 'connect_to_agent'
      },
      condition: {
        eq: [
          {
            system_variable: 'fallback_reason'
          },
          {
            scalar: 'Failed to confirm topic return'
          }
        ]
      },
      next_step: 'step_001',
      variable: 'digression_failure'
    }
  ],
  es: [
    {
      id: 'digression_failure',
      step: 'digression_failure',
      output: {
        generic: [
          {
            values: [
              {
                text: 'Lo siento, no he podido confirmar si desea volver al tema anterior, déjeme conectar con un agente.'
              }
            ],
            response_type: 'text',
            selection_policy: 'sequential'
          }
        ]
      },
      handlers: [],
      resolver: {
        response: {
          agent_available: {
            message:
              'Déjeme ponerle en contacto con un agente que esté disponible. '
          },
          agent_unavailable: {
            message:
              'No hay agentes disponibles en este momento. Cuando haya uno disponible, le pondré en contacto. '
          },
          message_to_human_agent: '',
          transfer_info: {
            target: {}
          }
        },
        type: 'connect_to_agent'
      },
      condition: {
        eq: [
          {
            system_variable: 'fallback_reason'
          },
          {
            scalar: 'Failed to confirm topic return'
          }
        ]
      },
      next_step: 'step_001',
      variable: 'digression_failure'
    }
  ],
  fr: [
    {
      id: 'digression_failure',
      step: 'digression_failure',
      output: {
        generic: [
          {
            values: [
              {
                text: "Désolé, je n'ai pas pu confirmer si vous souhaitiez revenir à la rubrique précédente. Permettez-moi de contacter un agent."
              }
            ],
            response_type: 'text',
            selection_policy: 'sequential'
          }
        ]
      },
      handlers: [],
      resolver: {
        response: {
          agent_available: {
            message: 'Je vais vous renvoyer à un agent disponible.'
          },
          agent_unavailable: {
            message:
              "Aucun agent n'est disponible pour le moment. Lorsqu'un agent sera disponible, nous vous mettrons en relation."
          },
          message_to_human_agent: '',
          transfer_info: {
            target: {}
          }
        },
        type: 'connect_to_agent'
      },
      condition: {
        eq: [
          {
            system_variable: 'fallback_reason'
          },
          {
            scalar: 'Failed to confirm topic return'
          }
        ]
      },
      next_step: 'step_001',
      variable: 'digression_failure'
    }
  ],
  it: [
    {
      id: 'digression_failure',
      step: 'digression_failure',
      output: {
        generic: [
          {
            values: [
              {
                text: "Purtroppo, non è stato possibile confermare se si desidera tornare all'argomento precedente, sarà effettuata la connessione ad un operatore."
              }
            ],
            response_type: 'text',
            selection_policy: 'sequential'
          }
        ]
      },
      handlers: [],
      resolver: {
        response: {
          agent_available: {
            message: 'Ti metto in contatto con il primo agente disponibile.'
          },
          agent_unavailable: {
            message:
              'Al momento non sono disponibili agenti. Appena un agente tornerà disponibile, ti ci metterò in contatto.'
          },
          message_to_human_agent: '',
          transfer_info: {
            target: {}
          }
        },
        type: 'connect_to_agent'
      },
      condition: {
        eq: [
          {
            system_variable: 'fallback_reason'
          },
          {
            scalar: 'Failed to confirm topic return'
          }
        ]
      },
      next_step: 'step_001',
      variable: 'digression_failure'
    }
  ],
  ja: [
    {
      id: 'digression_failure',
      step: 'digression_failure',
      output: {
        generic: [
          {
            values: [
              {
                text: '前のトピックに戻りたいかどうか確認できませんでした。エージェントに接続します。'
              }
            ],
            response_type: 'text',
            selection_policy: 'sequential'
          }
        ]
      },
      handlers: [],
      resolver: {
        response: {
          agent_available: {
            message: '利用できるエージェントに転送いたします。'
          },
          agent_unavailable: {
            message:
              '現時点で利用できるエージェントはありません。利用できるようになったら、お取り次ぎいたします。'
          },
          message_to_human_agent: '',
          transfer_info: {
            target: {}
          }
        },
        type: 'connect_to_agent'
      },
      condition: {
        eq: [
          {
            system_variable: 'fallback_reason'
          },
          {
            scalar: 'Failed to confirm topic return'
          }
        ]
      },
      next_step: 'step_001',
      variable: 'digression_failure'
    }
  ],
  ko: [
    {
      id: 'digression_failure',
      step: 'digression_failure',
      output: {
        generic: [
          {
            values: [
              {
                text: '죄송합니다. 이전 주제로 돌아가고 싶으신지 확인할 수 없습니다. 상담원과 연결해드리겠습니다.'
              }
            ],
            response_type: 'text',
            selection_policy: 'sequential'
          }
        ]
      },
      handlers: [],
      resolver: {
        response: {
          agent_available: {
            message: '사용 가능한 에이전트에 연결합니다.'
          },
          agent_unavailable: {
            message:
              '현재 사용 가능한 에이전트가 없습니다. 에이전트가 사용 가능해지면 연결됩니다.'
          },
          message_to_human_agent: '',
          transfer_info: {
            target: {}
          }
        },
        type: 'connect_to_agent'
      },
      condition: {
        eq: [
          {
            system_variable: 'fallback_reason'
          },
          {
            scalar: 'Failed to confirm topic return'
          }
        ]
      },
      next_step: 'step_001',
      variable: 'digression_failure'
    }
  ],
  nl: [
    {
      id: 'digression_failure',
      step: 'digression_failure',
      output: {
        generic: [
          {
            values: [
              {
                text: 'Sorry dat ik niet kon bevestigen of u terug wilde naar het vorige onderwerp, laat me verbinding maken met een agent.'
              }
            ],
            response_type: 'text',
            selection_policy: 'sequential'
          }
        ]
      },
      handlers: [],
      resolver: {
        response: {
          agent_available: {
            message: 'U wordt naar een beschikbare agent doorgezonden.'
          },
          agent_unavailable: {
            message:
              'Er zijn op dit moment geen agents beschikbaar. Als er een beschikbaar komt, verbinden we u. '
          },
          message_to_human_agent: '',
          transfer_info: {
            target: {}
          }
        },
        type: 'connect_to_agent'
      },
      condition: {
        eq: [
          {
            system_variable: 'fallback_reason'
          },
          {
            scalar: 'Failed to confirm topic return'
          }
        ]
      },
      next_step: 'step_001',
      variable: 'digression_failure'
    }
  ],
  pt: [
    {
      id: 'digression_failure',
      step: 'digression_failure',
      output: {
        generic: [
          {
            values: [
              {
                text: 'Desculpe, não pude confirmar se você queria retornar ao tópico anterior, deixe-me conectar a um agente.'
              }
            ],
            response_type: 'text',
            selection_policy: 'sequential'
          }
        ]
      },
      handlers: [],
      resolver: {
        response: {
          agent_available: {
            message: 'Vamos mandá-lo para um agente disponível.'
          },
          agent_unavailable: {
            message:
              'Não há agentes disponíveis neste momento. Quando houver um disponível, conectaremos você.'
          },
          message_to_human_agent: '',
          transfer_info: {
            target: {}
          }
        },
        type: 'connect_to_agent'
      },
      condition: {
        eq: [
          {
            system_variable: 'fallback_reason'
          },
          {
            scalar: 'Failed to confirm topic return'
          }
        ]
      },
      next_step: 'step_001',
      variable: 'digression_failure'
    }
  ],
  'zh-cn': [
    {
      id: 'digression_failure',
      step: 'digression_failure',
      output: {
        generic: [
          {
            values: [
              {
                text: '抱歉，我无法确认您是否要返回到先前主题，让我连接到代理程序。'
              }
            ],
            response_type: 'text',
            selection_policy: 'sequential'
          }
        ]
      },
      handlers: [],
      resolver: {
        response: {
          agent_available: {
            message: '请让我将您转给空闲的客服人员。'
          },
          agent_unavailable: {
            message: '目前客服人员全忙。客服人员空闲时，我们会联系您。'
          },
          message_to_human_agent: '',
          transfer_info: {
            target: {}
          }
        },
        type: 'connect_to_agent'
      },
      condition: {
        eq: [
          {
            system_variable: 'fallback_reason'
          },
          {
            scalar: 'Failed to confirm topic return'
          }
        ]
      },
      next_step: 'step_001',
      variable: 'digression_failure'
    }
  ],
  'zh-tw': [
    {
      id: 'digression_failure',
      step: 'digression_failure',
      output: {
        generic: [
          {
            values: [
              {
                text: '抱歉，我無法確認您是否要回到前一個主題，請讓我連接至代理程式.'
              }
            ],
            response_type: 'text',
            selection_policy: 'sequential'
          }
        ]
      },
      handlers: [],
      resolver: {
        response: {
          agent_available: {
            message: '讓我將您傳送給有空的客服人員。'
          },
          agent_unavailable: {
            message: '目前客服人員全忙。只要客服人員有空，我們就會聯絡您。'
          },
          message_to_human_agent: '',
          transfer_info: {
            target: {}
          }
        },
        type: 'connect_to_agent'
      },
      condition: {
        eq: [
          {
            system_variable: 'fallback_reason'
          },
          {
            scalar: 'Failed to confirm topic return'
          }
        ]
      },
      next_step: 'step_001',
      variable: 'digression_failure'
    }
  ]
};
